const MIN_LABEL_PX = 26

/** Measured in pixels, not share: on a 2000px board 2 of 32 routes is 6% but 125px. */
export function segmentFitsLabel(share: number, barWidth: number): boolean {
  return (barWidth * share) / 100 >= MIN_LABEL_PX
}
